import script from "./BurgerMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./BurgerMenu.vue?vue&type=script&setup=true&lang=js"

import "./BurgerMenu.vue?vue&type=style&index=0&id=dad805b0&lang=scss"

const __exports__ = script;

export default __exports__